import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Drawer, Toolbar, List, Divider, IconButton, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import LogoutIcon from '@mui/icons-material/Logout';
import { useLocation, useNavigate } from "react-router-dom";

import logo from "../assets/logo.svg";
import logoIcon from "../assets/logoIcon.svg";
import esercizi from '../assets/icons/esercizi.svg';
import eserciziB from '../assets/icons/eserciziB.svg';
import programmi from '../assets/icons/programmi.svg';
import programmiB from '../assets/icons/programmiB.svg';
import sessioni from '../assets/icons/sessioni.svg';
import sessioniB from '../assets/icons/sessioniB.svg';
import utenze from '../assets/icons/utenze.svg';
import utenzeB from '../assets/icons/utenzeB.svg';
import avatar from '../assets/icons/avatar.svg';
import nav from '../assets/icons/nav.svg';
import navExpanded from '../assets/icons/nav_expanded.svg';
import FilterBar from './FilterBar';
import { ModalAlert, ModalData, modalDataClean, MODALTYPE } from './ModalAlert';
import { Logout } from '@mui/icons-material';

const drawerWidth = 240;

const menu = [
    { text: "Esercizi", icon: <img src={esercizi} alt="icon" width={30} />, iconSelect: <img src={eserciziB} alt="icon" width={30} />, path: "/esercizi" },
    { text: "Sessioni", icon: <img src={sessioni} alt="icon" width={30} />, iconSelect: <img src={sessioniB} alt="icon" width={30} />, path: "/sessioni" },
    //{ text: "Programmi", icon: <img src={programmi} alt="icon" width={30} />, iconSelect: <img src={programmiB} alt="icon" width={30} />, path: "/programmi" },
    { text: "Utenze", icon: <img src={utenze} alt="icon" width={30} />, iconSelect: <img src={utenzeB} alt="icon" width={30} />, path: "/utenze" },
];
interface NavProps {
    isNavOpen: boolean;
    setIsNavOpen: (open: boolean) => void;
    //token: string;
    //setToken: (token: string | null) => void;
    userName: string;
    onLogout: () => void;
}

//export default function Nav({ isNavOpen, setIsNavOpen, token, setToken, userName }: NavProps) {
export default function Nav({ isNavOpen, setIsNavOpen, userName, onLogout }: NavProps) {
    const [modalData, setModalData] = React.useState<ModalData>(modalDataClean);

    const theme = useTheme();
    const location = useLocation();
    const navigate = useNavigate();
    const [error, setError] = React.useState<string | null>(null);

    const handleDrawerToggle = () => {
        setIsNavOpen(!isNavOpen)
    };

    const LogoutODM = async () => {
        try {
            const headers = new Headers();
            //if (token) {
            //    headers.set('Authorization', `Token ${token}`);
            //}
            headers.set('Accept', 'application/json');

            const response = await fetch('/api/v0/logout', {
                method: 'POST',
                headers: headers,
                credentials: 'include',
            });

            if (response.ok) {
                //setToken(null)
                navigate("/login");
                onLogout()
            } else {
                const errorData = await response.json();
                setError(errorData.error);
            }
        } catch (error) {
            setError('Si è verificato un errore, per favore riprova più tardi.');
        }
    };

    const closeModal = () => setModalData(prev => ({ ...prev, show: false }));

    return (
        <Drawer
            variant="permanent"
            open={isNavOpen}
            sx={{
                width: isNavOpen ? drawerWidth : 60,
                flexShrink: 0,
                "& .MuiDrawer-paper": {
                    width: isNavOpen ? drawerWidth : 60,
                    transition: theme.transitions.create("width", {
                        duration: theme.transitions.duration.enteringScreen,
                    }),
                    overflowX: 'hidden',
                },
            }}
        >

            <ListItem disablePadding>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        p: 2,

                    }}
                >
                    <IconButton onClick={handleDrawerToggle} edge="start">
                        <img src={isNavOpen ? navExpanded : nav} alt="nav" width={22} />
                    </IconButton>
                </Box>
            </ListItem>

            <Divider />


            <ListItem disablePadding>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "left",
                        width: "100%",
                        p: 1
                    }}
                >
                    <img
                        src={isNavOpen ? logo : logoIcon}
                        alt="logo"
                        style={{
                            display: "flex",
                            marginLeft: isNavOpen ? "-27px":"0px",
                            height: 45,
                            width: isNavOpen ? 240 : 45,
                           
                        }}
                    />
                </Box>
            </ListItem>
            <Divider />
            <hr className='mt-3 mb-0  mx-3' />
            <List>
                {menu.map((item, index) => (
                    <ListItem key={index} disablePadding>
                        <ListItemButton
                            sx={{
                                backgroundColor: location.pathname === item.path ? "#0D5C37" : "transparent",
                                color: location.pathname === item.path ? "white" : "black",
                                borderRadius: "10px",
                                margin: "5px",
                                display: "flex",
                                alignItems: "center",
                                pl: 1,
                                pr: 1,
                                "&:hover": {
                                    backgroundColor: "#d3d3d3", // colore al passaggio
                                },
                            }}
                            onClick={() => navigate(item.path)}
                        >
                            <ListItemIcon
                                sx={{
                                    color: location.pathname === item.path ? "#0D5C37" : "black",
                                    minWidth: 40,
                                    display: "flex",
                                    justifyContent: "flex-start",
                                }}
                            >
                                {location.pathname === item.path ? item.iconSelect : item.icon}
                            </ListItemIcon>
                            {isNavOpen && (
                                <ListItemText
                                    primary={item.text}
                                    sx={{ whiteSpace: "nowrap", ml: 2 }}
                                />
                            )}
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>

            <Divider />


            <Box sx={{ flexGrow: 1 }} />
            <hr className='mt-3 mb-0  mx-3' />
            <ListItem disablePadding>
                <ListItemButton sx={{ pl: 2 }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <img src={avatar} alt="avatar" width={30} />
                        {isNavOpen && (
                            <ListItemText
                                primary={userName}
                                sx={{ ml: 2, whiteSpace: "nowrap" }}
                            />
                        )}
                    </Box>
                </ListItemButton>
                {isNavOpen && (
                    <IconButton
                        onClick={() =>
                            setModalData({
                                show: true,
                                title: "Logout",
                                message: "Sicuro di voler uscire?",
                                type: MODALTYPE.LOG,
                                action: () => LogoutODM(),
                            })
                        }
                        sx={{ ml: 1 }}
                    >
                        <LogoutIcon />
                    </IconButton>
                )}
            </ListItem>

            {!isNavOpen && (
                <ListItem disablePadding sx={{ justifyContent: "center" }}>
                    <ListItemButton
                        onClick={() =>
                            setModalData({
                                show: true,
                                title: "Logout",
                                message: "Sicuro di voler uscire?",
                                type: MODALTYPE.LOG,
                                action: () => LogoutODM(),
                            })
                        }
                        sx={{ pl: 2 }}
                    >
                        <LogoutIcon />
                    </ListItemButton>
                </ListItem>
            )}
            <ModalAlert modalData={modalData} onClose={closeModal} />
        </Drawer>
    );
}
